import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import styles from "./Navbar.module.css";

export default function Navbar() {
  const { user, logout, isAdmin } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  if (!user) return null;

  const isActive = (path) => location.pathname === path;
  const handleLogout = () => { logout(); navigate("/login"); setMenuOpen(false); };
  const close = () => setMenuOpen(false);

  const customerLinks = [
    { to: "/chat", label: "Chat" },
    { to: "/products", label: "Products" },
    { to: "/orders", label: "My Orders" },
  ];
  const adminLinks = [
    { to: "/admin", label: "Dashboard" },
    { to: "/admin/products", label: "Products" },
    { to: "/admin/orders", label: "Orders" },
  ];
  const links = isAdmin ? adminLinks : customerLinks;

  return (
    <>
      <nav className={styles.nav}>
        <Link to={isAdmin ? "/admin" : "/chat"} className={styles.logo} onClick={close}>
          <span className={styles.logoIcon}>◈</span>
          <span>ShopBot</span>
        </Link>

        <div className={styles.links}>
          {links.map(l => (
            <Link key={l.to} to={l.to} className={`${styles.link} ${isActive(l.to) ? styles.active : ""}`}>{l.label}</Link>
          ))}
        </div>

        <div className={styles.right}>
          <span className={styles.userName}>{user.name}</span>
          <button className="btn btn-ghost" style={{padding:"7px 14px",fontSize:"13px"}} onClick={handleLogout}>Logout</button>
        </div>

        <button className={styles.hamburger} onClick={() => setMenuOpen(o => !o)} aria-label="Menu">
          {menuOpen
            ? <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            : <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          }
        </button>
      </nav>

      <div className={`${styles.mobileMenu} ${menuOpen ? styles.open : ""}`}>
        {links.map(l => (
          <Link key={l.to} to={l.to} onClick={close}
            className={`${styles.mobileLink} ${isActive(l.to) ? styles.active : ""}`}>{l.label}</Link>
        ))}
        <div className={styles.mobileBottom}>
          <span className={styles.mobileUser}>{user.name}</span>
          <button className="btn btn-ghost" style={{padding:"6px 14px",fontSize:"13px"}} onClick={handleLogout}>Logout</button>
        </div>
      </div>
    </>
  );
}
